import React from "react";
import classnames from "classnames";

const Icons = {};

Icons.Pencil = ({ size }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 16 16"
    className="bi bi-pencil"
    fill="currentColor"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      d="M11.293 1.293a1 1 0 0 1 1.414 0l2 2a1 1 0 0 1 0 1.414l-9 9a1 1 0 0 1-.39.242l-3 1a1 1 0 0 1-1.266-1.265l1-3a1 1 0 0 1 .242-.391l9-9zM12 2l2 2-9 9-3 1 1-3 9-9z"
    />
    <path
      fillRule="evenodd"
      d="M12.146 6.354l-2.5-2.5.708-.708 2.5 2.5-.707.708zM3 10v.5a.5.5 0 0 0 .5.5H4v.5a.5.5 0 0 0 .5.5H5v.5a.5.5 0 0 0 .5.5H6v-1.5a.5.5 0 0 0-.5-.5H5v-.5a.5.5 0 0 0-.5-.5H3z"
    />
  </svg>
);

Icons.Plus = ({ size }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 16 16"
    className="bi bi-plus"
    fill="currentColor"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      d="M8 3.5a.5.5 0 0 1 .5.5v4a.5.5 0 0 1-.5.5H4a.5.5 0 0 1 0-1h3.5V4a.5.5 0 0 1 .5-.5z"
    />
    <path
      fillRule="evenodd"
      d="M7.5 8a.5.5 0 0 1 .5-.5h4a.5.5 0 0 1 0 1H8.5V12a.5.5 0 0 1-1 0V8z"
    />
  </svg>
);

Icons.ChevronDown = ({ size }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 16 16"
    className="bi bi-chevron-down"
    fill="currentColor"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      d="M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708z"
    />
  </svg>
);

Icons.ChevronRight = ({ size }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 16 16"
    className="bi bi-chevron-right"
    fill="currentColor"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      d="M4.646 1.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1 0 .708l-6 6a.5.5 0 0 1-.708-.708L10.293 8 4.646 2.354a.5.5 0 0 1 0-.708z"
    />
  </svg>
);

const IconButton = ({
  onClick,
  disabled,
  className,
  icon,
  children,
  size = "1.5rem",
  ...props
}) => {
  const Icon = Icons[icon];
  return (
    <div
      className={classnames("icon-button", disabled && "disabled", className)}
      onClick={disabled ? () => {} : onClick}
      {...props}
    >
      <div className="d-flex align-items-center">
        <Icon size={size} />
        {children}
      </div>
    </div>
  );
};

export default IconButton;
